"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var Tree_1 = require("../../components/Tree");
var commonFunctions_1 = require("../../helpers/commonFunctions");
var TaxesTreeComponent = /** @class */ (function (_super) {
    __extends(TaxesTreeComponent, _super);
    function TaxesTreeComponent(props) {
        return _super.call(this, props) || this;
    }
    TaxesTreeComponent.prototype.render = function () {
        var taxes = [];
        for (var _i = 0, _a = this.props.coverage.amounts; _i < _a.length; _i++) {
            var amount = _a[_i];
            var regex = /Tax/g;
            if (regex.test(amount.amountText)) {
                taxes.push((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "".concat(amount.amountText, " ").concat((0, commonFunctions_1.getAmountToDisplay)(amount.amount)) }, amount.amountText));
            }
        }
        return taxes.length > 0 ? taxes : null;
    };
    TaxesTreeComponent = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], TaxesTreeComponent);
    return TaxesTreeComponent;
}(React.Component));
exports.default = TaxesTreeComponent;
//# sourceMappingURL=TaxesTreeComponent.js.map